import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './Home';
import ProtectedLoveLetter from './ProtectedLoveLetter';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/120425" element={<ProtectedLoveLetter />} />
    </Routes>
  );
}

export default App;
